import axios from "../../axios";

const fetchPromotionStatus = async (promotion_id) => {
  try {
    const { data } = await axios.get(`/messages/promotions/${promotion_id}`);
    return data;
  } catch (e) {
    return null;
  }
};

export {
  fetchPromotionStatus
}